import { useEffect, useState } from "react";
import SidebarComponent from "./sidebar/Sidebar";

const Layout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    //
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {!isMobile ? (<div
        style={{
          overflowY: "hidden",
        }}
      >
        <div className="d-flex col-lg-12">
          <div className="">
            <SidebarComponent />
          </div>
          <div className="w-100">
            {" "}
            <div
              style={{
                height: "100vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>) : (<div>{children}</div>)}
    </>
  );
};

export default Layout;
